import { RELATIONSHIP_BASE_URL, ROUTER_BASENAME } from 'config';

const redirectToRelationship = () => {
  const search = window.location.search;
  const redirectPath = window.location.pathname.replace(ROUTER_BASENAME || '', '').replace('/business', '');

  const bookingIdPattern = /\/bookings\/[a-zA-Z0-9-]+(?:\/|$)/;
  const hasBookingId = bookingIdPattern.test(redirectPath);

  const relationshipUrl = hasBookingId ? `${RELATIONSHIP_BASE_URL}${redirectPath}${search}` : `${RELATIONSHIP_BASE_URL}${search}`;

  window.location.replace(relationshipUrl);
};

export default redirectToRelationship;
